module.exports = __webpack_public_path__ + "static/bill_small2rope-8a8e973d99107a2f3485c4eff76b7cb8.png";